import { DropDown, JsonData, OdinController } from '@myosh/odin-components';
import { t } from 'i18next';
import { Control } from 'react-hook-form';
import { handleHFDropdownChange } from '../../../../helpers/dropdown';

interface WidgetGlobalFilterProps {
  data: JsonData;
  control: Control;
  resetGlobalFiltersValues: () => void;
}

const WidgetGlobalFilterComponent = ({ data, control, resetGlobalFiltersValues }: WidgetGlobalFilterProps) => {
  return (
    <div className="my-1 py-2">
      <OdinController
        name="globalFilters"
        control={control}
        render={({ field: { onChange, value } }) => (
          <DropDown
            allowClear
            label={t('globalFilters')}
            setDefaultValue={false}
            data={data}
            textField="field"
            valueField="field"
            pageSize={50}
            value={value}
            onChange={(value) =>
              handleHFDropdownChange({ value, onChange, clearValueCallback: resetGlobalFiltersValues })
            }
          />
        )}
      />
    </div>
  );
};

export default WidgetGlobalFilterComponent;
